import InlineReplacement from './base/inline-replacement';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
export default InlineReplacement.extend().reopenClass({
  delimiter: /(^|\s)[^\s]*$/,
  tryReplacementWithIndex(block, index) {
    let replacementCount = this.tryReplacement(block);
    if (replacementCount > 0 && index) {
      let indexAfterReplacement = index - replacementCount * 2;
      let blockRange = BlockRange.atPositionIndex(indexAfterReplacement);
      let entitiesInRange = block.get('entities').byTypeWithinRange('code', blockRange);
      if (entitiesInRange.length === 1 && entitiesInRange.get('firstObject.endIndex') === indexAfterReplacement) {
        block.insertCharacter(blockRange, {
          character: ' '
        });
      }
    }
    return replacementCount;
  },
  tryReplacement(block, mutationResult) {
    if (block.get('config.markdownInlineCode')) {
      let regex = new RegExp(/`([^`\n]+)`/g);
      let captureGroupMappings = ['text'];
      return InlineReplacement._doInlineReplacement(block, regex, 'code', captureGroupMappings, mutationResult);
    }
  }
});